"use client";

import { useIntentActions } from "@/hooks/use-intent-actions";

/**
 * Invisible component that handles Siri/widget intent actions.
 * Must be rendered inside DashboardProvider context.
 */
export function IntentActionsHandler() {
  useIntentActions();
  return null;
}
